import { derivePaletteNumbers } from "@yjsgames/theme";
import { THEME } from "./activeTheme.js";

/** 의미 팔레트 — 문자열 hex. Phaser Text color 등 문자열 색 자리에 사용. */
export const PALETTE = THEME.palette;

/** 숫자 팔레트 — Phaser fillStyle/lineStyle/tint 등 숫자 색 자리에 사용 (부팅 시 1회 파생). */
export const PALETTE_NUM = derivePaletteNumbers(THEME.palette);
